const CurrentOwner = {
  current: null
}

export default CurrentOwner
